export default {"src":"/_next/static/media/calendar.a297c575.svg","height":20,"width":20};